module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ManuallyDetailView.js"));
	}, "ManuallyDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ManuallyDetailView!./src/pages/MessageManage/ManuallyDetail/ManuallyDetailView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=ManuallyDetailView!./src/pages/MessageManage/ManuallyDetail/ManuallyDetailView.js
// module chunks = 43